<template>
<transition name="fade" mode="out-in">
  <li class="prize-list-item"
  v-if="!smallDisplay || active && smallDisplay"
  :class="{
    'prize-list-item--active': active,
    'prize-list-item--small-display': smallDisplay,
  }">
    <span class="prize-list-item__indicator" @click="handlePrizeItemClick">
      <span class="prize-list-item__indicator--background" />
      <span class="prize-list-item__indicator--number">{{displayIndex}}</span>
    </span>
    <div class="prize-list-item__content">
      <h4 class="prize-list-item__content__title">{{title}}</h4>
      <p class="prize-list-item__content__copy">{{copy}}</p>
    </div>
  </li>
</transition>
</template>

<script>
/**
 * item in the prize list
 */
export default {
  name: 'prize-list-item',
  props: {
    title: { type: String, required: true },
    copy: { type: String, required: true },
    index: { type: Number, required: true },
    active: { type: Boolean },
    smallDisplay: {
      type: Boolean
    }
  },
  computed: {
    displayIndex() {
      return this.index + 1;
    },
  },
  methods: {
    handlePrizeItemClick() {
      this.$emit('click', this.index);
    }
  }
};
</script>

<style lang="scss">
.prize-list-item {
  display: flex;

  margin-bottom: 7.5rem;
  height: 8.2rem;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }
  &__indicator {
    flex: 0 0 auto;
    width: $size-width-prize-indicator;
    height: $size-height-prize-indicator;
    position: relative;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    font-size: $size-font-size-prize-indicator;
    border: $size-border-width-prize-indicator solid $color-base-ninja-yellow-base;
    color: $color-base-white-base;
    font-family: $font-family-base;
    border-radius: $size-border-radius-prize-indicator;
    &--number {
      z-index: 2;
      transition: color 250ms ease;
    }
    &--background {
      z-index: 1;
      display: block;
      background-color: $color-base-ninja-yellow-base;
      width: 0;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      transition: width 300ms ease;
    }
  }
  &__content {
    margin: 0 $size-margin-prize-indicator;
    position: absolute;
    left: 8.2rem;
    top: 50%;
    transform: translateY(-50%);

    &__copy {
      @include body-copy-small;
      max-width: $size-width-prize-copy;
    }
    &__title {
      margin: 0 0 $size-margin-prize-title 0;
      font-size: $size-font-size-prize-title;
      line-height: $size-line-height-prize-title;
      color: $color-base-white-base;
      font-family: $font-family-prize-title;
      font-weight: $font-weight-prize-title;
    }
  }
  &--active {
    .prize-list-item__indicator {
      &--background {
        width: 100%;
        left: 0;
      }
      &--number {
        color: $color-base-black-base;
      }
    }
  }
  &--small-display {
    text-align: center;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 100%;
    .prize-list-item__content {
      height: auto;
      left: auto;
      transform: none;
      top: auto;
      position: static;
      &__copy {
        margin: {
          left: auto;
          right: auto;
        }
      }
    }
    .prize-list-item__indicator {
      display: none;
    }
  }
}
</style>
